import { request } from '../@utils'
import { requestFile } from '../@utils'
const PurchaseOrderService = {
  getList: params => {
    return request.post('purchase-order/list', {
      data: params
    })
  },
  getInfoById: id => {
    return request.get(`purchase-order/info/${id}`)
  },
  billsDiscard: (ids = []) => {
    return request.post(`purchase-order/bills-discard`, { data: { ids } })
  },
  getDetailProductList: data => {
    return request.post(`purchase-order/detail/list`, { data })
  },
  createBill: data => {
    return request.post(`purchase-order/create`, { data })
  },
  export: data => {
    return requestFile.post(`purchase-order/export`, {
      data: data,
      responseType: 'blob'
    })
  },
  getCountMoney: data => {
    return request.post(`purchase-order/count-money`, { data })
  },
  markPayStatus: data => {
    return request.post(`purchase-order/mark-pay-status`, { data })
  },
  getRefCostPrice: data => {
    return request.post(`purchase-order/product-details`, { data })
  }
}

export default PurchaseOrderService
